











































































































































import {Component, Prop, Vue} from "vue-property-decorator";

import Post from "@/components/timeline/_post.vue";
import TiptapSns from "@/components/timeline/_tiptapSns.vue";
import {dateFormat} from "@/script/moment";
import {AxiosError, AxiosResponse} from "axios";
import LikeBtn from "@/components/timeline/_likeBtn.vue";
import UserAvatar from "@/components/user/_userAvatar.vue";

import {mapGetters} from "vuex";
import {scrollDone} from "@/script/scrollManager";
import {execCommandCopy} from "@/script/util";
import Toast from "@/script/message";
import CommentInput from "@/components/comment/_commentInput.vue";
import Comment from "@/components/timeline/Comment.vue";
import {Swiper, SwiperSlide} from "vue-awesome-swiper";

@Component({
    components: {
        Post,
        TiptapSns,
        LikeBtn,
        UserAvatar,
        CommentInput,
        Swiper,
        SwiperSlide,
        Comment
    },
    computed: {...mapGetters(["user"])},
})
export default class Feed extends Vue {
    @Prop() feed!: any;

    toast = new Toast();
    isOpenedComments: boolean = false;
    likeList: any = [];

    attachedFile: any = '';
    hashtags: any = '';

    originImg: string = "";

    limit: number = 5;
    offset: number = 0;
    sort: string = '';

    isAddData: boolean = false;
    comments: any = [];
    user!: any;
    isOpenReportModal = false;

    isOverflow: boolean | null = null;
    isMoreView: boolean | null = null;
    currScroll: number = 0;

    commentCnt: number = 0;

    swiperOption = {
        pagination: {
            el: '.swiper-pagination'
        }
    }

    mounted() {
        this.attachedFile = Array.isArray(this.feed.attatchment_files) ? this.feed.attatchment_files : JSON.parse(this.feed.attatchment_files)
        this.hashtags = this.feed.hashtags;
        this.checkOverflow()
        this.commentCnt = this.feed?.comment_cnt;
        // this.likeListFetch();
    }

    scrollCheck(e) {
        console.log(e.tartget)
        if (scrollDone(e.target)) {

            this.offset += this.limit;
            this.commentFetch();
        }
    }

    dateFormat(date: number) {
        return dateFormat(date);
    }


    openComments() {

        this.commentInit();
        this.isOpenedComments = !this.isOpenedComments;

        if (this.isOpenedComments && this.feed.comment_cnt > 0) {
            this.comments = []
            this.commentFetch()
        }

    }

    likeListFetch() {
        const obj = {
            post_id: this.feed.id,
            limit: this.limit,
            offset: this.offset
        }
        this.$api.likeList(obj)
            .then((res: AxiosResponse) => {
                this.likeList = res;
            })
            .catch((err: AxiosError) => {

            })


    }


    copyUrl() {
        execCommandCopy(`${this.$store.getters.communityUrl}feed/${this.feed.id}`)
        this.toast.clear();
        this.toast.successToast(`${this.$t('copied.clipboard')}`)
    }


    //post
    contentClicked(e: any) {
        // if (e.target.matches("img")) {
        //     this.originImg = e.target.src;
        //     // this.$modal.show('originImgModal')
        //     this.$emit('originImg', this.originImg)
        // }
        // else if (e.target.matches(".hashtag")) {
        //     this.$router.push(
        //         `/search?hashtag=${e.target.attributes["data-id"].nodeValue}`
        //     );
        // }
        // else if (e.target.matches(".mention")) {
        //     this.$router.push(
        //         `/channel/${e.target.attributes["channel-id"].nodeValue}/timeline`
        //     );
        // }
        // else {
        this.$router.push(`/${this.$i18n.locale}/feed/${this.feed.id}`);
        // }
    }

    moveHashtag(hashtag: string) {
        this.$router.push(`/${this.$i18n.locale}/search?hashtag=${hashtag}`)
    }

    commentFetch() {
        const obj = {
            limit: this.limit,
            offset: this.offset,
            sort: this.sort
        }
        this.$api.comments(this.feed.id, obj)
            .then((res: any) => {
                if (this.isAddData) {
                    if (res.result.length > 0) {
                        this.comments = [...this.comments, ...res.result]
                    }
                    else {
                        // console.log('no data')
                    }
                }
                else {
                    this.comments = res.result;
                    this.isAddData = true
                }
            })
            .catch((err: AxiosError) => {

            })
            .finally(() => {

            })
    }


    openEdit() {
        this.$modal.show('modalPost')
        this.$store.commit('feed', this.feed)
    }

    pinPost() {
        console.log("pinned");
    }

    closeModal() {
        this.$modal.hide('noUser')

    }

    deletePost() {
        this.$emit('deleteFeed', this.feed.id)
        this.$modal.show('deleteModal')

    }

    report() {
        this.$emit('reportPost', this.feed.id)
        this.isOpenReportModal = !this.isOpenReportModal
        this.$modal.show('modalReport')
    }

    /**
     * 더보기
     * */
    checkOverflow() {
        const ref = this.$refs.contentDiv;

        if ((ref as any).clientHeight >= 450) {
            this.isOverflow = true;
        }
    }

    moreView() {
        const ref = this.$refs.contentDiv;
        (ref as any).style.maxHeight = '100%';
        this.isOverflow = false;
        this.isMoreView = true;
        this.currScroll = document.documentElement.scrollTop;

    }

    closeView() {
        const ref = this.$refs.contentDiv;
        (ref as any).style.maxHeight = '500px';
        this.isOverflow = true;
        this.isMoreView = false;
        window.scrollTo(0, this.currScroll);
    }

    /**
     * 댓글
     * */
    commentInit() {
        this.comments = [];
        this.limit = 5;
        this.offset = 0;
        this.sort = '';
    }

    deleteComment(commentId: string) {
        this.commentCnt--;
        this.commentInit();
        this.$api.deleteComment(this.feed.id, commentId)
            .then((res: AxiosResponse) => {
                this.commentFetch()
            })
            .catch((err: AxiosError) => {

            })
    }

    editDone(comment:any) {
        this.commentCnt++;
        this.comments = [comment, ...this.comments]

        // this.commentInit();
        // this.commentFetch()
    }

    updateDone() {
        // this.commentInit();
        // this.commentFetch()
    }

    /**
     * 유저 신고
     */

    userReportModalOpen() {
        // this.$emit('reportPost', this.feed.id)
        // this.isOpenReportModal = !this.isOpenReportModal
        this.$modal.show('modalUserReport')
    }

    userReport(){
        console.log("?")
    }
}
